import type { ErrorComponentProps } from "@tanstack/react-router"

import Link from "@/components/link"
import { ErrorPanel } from "@anysola/ui/error-panel"
import { asError, digestOf, useRetry } from "@/components/feedback/site-error"
import { MonitorClientError } from "@/components/monitor-client-error"
import { Button } from "@anysola/ui/button"
import { siteConfig } from "@/lib/site"

/**
 * `app/global-error.tsx`: what renders when the document itself failed (the
 * root route), inside a bare document of its own (`RootDocument` in
 * `routes/__root.tsx` wraps it).
 */
export const GLOBAL_ERROR_BODY =
  "flex min-h-screen items-center justify-center bg-background p-6 text-foreground"

export function GlobalErrorBody({ error, reset }: ErrorComponentProps) {
  const retry = useRetry(reset)
  return (
    <>
      <MonitorClientError error={asError(error)} scope="global" />
      <main
        id="main-content"
        tabIndex={-1}
        className="w-full max-w-3xl outline-none"
      >
        <ErrorPanel
          title="Something went wrong."
          description={`Or email ${siteConfig.contactEmail}.`}
          digest={digestOf(error)}
        >
          <Button type="button" onClick={retry}>
            Try again
          </Button>
          <Button variant="secondary" render={<Link href="/" />}>
            Back to home
          </Button>
        </ErrorPanel>
      </main>
    </>
  )
}
